import { makeApi } from "@zodios/core";
import { z } from "zod";

import {
  LineAdsAccountListResponseSchema,
  LineAdsGroupSchema,
  RegisterLineAdsGroupRequestSchema,
} from "../models";

const EmptyResponseSchema = z.union([z.void(), z.literal("")]);

const api = makeApi([
  {
    alias: "registerGroup",
    method: "post",
    path: "/api/v1/line-ads/group",
    parameters: [
      { type: "Body", name: "body", schema: RegisterLineAdsGroupRequestSchema },
    ],
    response: LineAdsGroupSchema,
  },
  {
    alias: "getGroup",
    method: "get",
    path: "/api/v1/line-ads/group",
    parameters: [
      { type: "Query", name: "checkAccess", schema: z.boolean().optional() },
    ],
    response: LineAdsGroupSchema,
  },
  {
    alias: "disconnectGroup",
    method: "delete",
    path: "/api/v1/line-ads/group",
    response: EmptyResponseSchema,
  },
  {
    alias: "listAccounts",
    method: "get",
    path: "/api/v1/line-ads/group/accounts",
    response: LineAdsAccountListResponseSchema,
  },
  {
    alias: "deleteAccount",
    method: "delete",
    path: "/api/v1/line-ads/group/accounts/:accountId",
    parameters: [{ type: "Path", name: "accountId", schema: z.number().int() }],
    response: EmptyResponseSchema,
  },
  {
    alias: "reloadAccounts",
    method: "post",
    // Percent-encoded: zodios reads a bare `:reload` as a path parameter.
    path: "/api/v1/line-ads/group/accounts%3Areload",
    response: EmptyResponseSchema,
  },
]);

export { api };
